import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
  Button,
  IconButton,
  Box,
} from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";

export interface ConfirmarAlteracaoEstadoDialogProps {
  open: boolean;
  titulo: string;
  mensagem: string;
  textoBotaoConfirmar?: string;
  isLoading?: boolean;
  onConfirmar: () => void;
  onCancelar: () => void;
}

/**
 * FASE 05 - T-09/T-10/T-11: dialog de confirmação reusável para os botões
 * HOMOLOGAR, CONCLUIR HOMOLOGAÇÃO e DISPONIBILIZAR MERCADO.
 *
 * Os textos são passados via props para permitir reuso com as três mensagens
 * exatas exigidas pelo relatório de funcionamento inadequado (FASE 05).
 */
export const ConfirmarAlteracaoEstadoDialog: React.FC<ConfirmarAlteracaoEstadoDialogProps> = ({
  open,
  titulo,
  mensagem,
  textoBotaoConfirmar = "CONTINUAR",
  isLoading = false,
  onConfirmar,
  onCancelar,
}) => {
  return (
    <Dialog open={open} onClose={isLoading ? undefined : onCancelar} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", pb: 1 }}>
        <Box component="span" sx={{ fontWeight: 600 }}>{titulo}</Box>
        <IconButton size="small" onClick={onCancelar} disabled={isLoading}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <DialogContentText sx={{ color: "#333", whiteSpace: "pre-wrap" }}>
          {mensagem}
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button onClick={onCancelar} disabled={isLoading} variant="outlined">
          CANCELAR
        </Button>
        <Button onClick={onConfirmar} disabled={isLoading} variant="contained" color="primary">
          {textoBotaoConfirmar}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
